import d3 from "d3";
import R from "ramda";
import topojson from "topojson";

const {random, sin, PI: π} = Math;

export default function createIndicatorMap(initialState){

    const state = {
        "selector": "",
        "width": 0,
        "usShape": null,
        "hrrCentroids": null
    };

    function setState(newState){
        Object.assign(state, newState);
        update();
    }

    // merge the initial state in with the default state before we build the svg
    Object.assign(state, initialState);


    const svg = d3.select(state.selector).append("svg");

    const margin = { top: 20, right: 20, bottom: 20, left: 20};
    const g = svg.append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    update();

    function update(){

        // update width/height
        svg.attr("width", state.width).attr("height", state.width * .66);

        const projection = d3.geo.albersUsa()
            .scale(state.width * 1.2)
            .translate([state.width/2, state.width * 0.295]);
        const projectHrr = R.compose(projection, R.prop("centroid"));
        const projectHrrX = R.compose(R.nth(0), projectHrr);
        const projectHrrY = R.compose(R.nth(1), projectHrr);
        const path = d3.geo.path().projection(projection);

        // 8 second shimmer duration, 4 second period
        const shimmerDuration = 8000,
            shimmerPeriod = 4000,
            shimmerCount = shimmerDuration/shimmerPeriod;

        const shimmerTween = t => (sin((t * shimmerCount * 2 * π) + (π / 4)) / 2) + 0.5;

        // these are required beyond this point
        if (!state.usShape || !state.hrrCentroids){ return; }

        const usShapeData = topojson.feature(state.usShape, state.usShape.objects.us);

        let outline = g.select("path.us-outline");

        if (outline.empty()){
            outline = g.append("path")
                .attr("class", "us-outline")
                .datum(usShapeData);
        }

        outline.attr("d", path);

        const hrrDots = g.selectAll("circle.hrr-dot").data(state.hrrCentroids, R.prop("id"));

        hrrDots.enter()
            .append("circle")
            .attr("class", "hrr-dot")
            .attr("r", 2.5)
            .style("opacity", 0);

        hrrDots.exit().remove();

        hrrDots
            .attr("cx", projectHrrX)
            .attr("cy", projectHrrY)
            .transition().duration(shimmerDuration).ease("linear")
            .delay(() => random() * shimmerPeriod * 4)
            .styleTween("opacity", () => shimmerTween);
    }

    return {
        setState
    };
}
